import { Tabs } from 'antd';
import React from 'react';
import { SetURLSearchParams } from 'react-router-dom';
import './Tab.css';

interface BaseProps {
  key: string;
  title: string;
  component: React.ReactNode;
}

interface TabProps {
  components: BaseProps[];
  searchParams?: URLSearchParams;
  setSearchParams?: SetURLSearchParams;
}

const Tab: React.FC<TabProps> = ({ components, searchParams, setSearchParams }) => {
  const items = components.map(component => ({
    key: component.key,
    label: component.title,
    children: component.component,
  }));

  const handleTabChange = (key: string): void => {
    if (setSearchParams) {
      setSearchParams(prev => {
        prev.set('tab', key);
        return prev;
      });
    }
  };

  return (
    <div className="tabs-container">
      <Tabs
        defaultActiveKey={searchParams?.get('tab') || 'detail'}
        items={items}
        onChange={handleTabChange}
      />
    </div>
  );
};

export default Tab;
